import { useLayoutEffect, useRef } from "react"
import { ButtonTertiary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { InputOutlined } from "@nova/ds-component-input"
import { MapCommentSort } from "plugins/Toolbox/MapComments/CommentSlice"
import { MapCommentFilterMenu } from "./MapCommentFilterMenu"
import { CommentVisibilityMenu } from "./CommentVisibilityMenu"
import { closeMapComment } from "./module"

export const CommentListHeader = ({
    search,
    onSearchChange,
    creatorId,
    onCreatorChange,
    sort,
    onSortChange,
    showControls,
    onHeightChange,
}: {
    search: string
    onSearchChange: (search: string) => void
    creatorId: string
    onCreatorChange: (creatorId: string) => void
    sort: MapCommentSort
    onSortChange: (sort: MapCommentSort) => void
    showControls: boolean
    onHeightChange: (height: number) => void
}) => {
    const headerRef = useRef<HTMLDivElement>(null)

    useLayoutEffect(() => {
        const header = headerRef.current
        if (!header) return
        const observer = new ResizeObserver(() => onHeightChange(header.offsetHeight))
        observer.observe(header)
        return () => observer.disconnect()
    }, [onHeightChange])

    return (
        <div className="absolute inset-x-0 top-0 z-10 rounded-t-xl">
            <div
                aria-hidden
                className="absolute inset-x-0 top-0 h-[calc(100%+1.5rem)] bg-gradient-to-b from-black-1000 via-black-1000/80 to-transparent backdrop-blur-md [mask-image:linear-gradient(to_bottom,black_60%,transparent)] rounded-t-xl"
            />
            <div ref={headerRef} className="relative px-4 pt-4 pb-1">
                <div className="flex">
                    <small className="text-gray-300 mr-auto content-center tracking-[1.2px]">
                        COMMENTS
                    </small>
                    <Icons.SmallIcon
                        Icon={Icons.XClose}
                        className="text-gray-300 hover:text-gray-0 cursor-pointer"
                        onClick={closeMapComment}
                    />
                </div>
                {showControls && (
                    <div className="flex gap-1 py-2">
                        <InputOutlined
                            className="text-white"
                            leftItem={<Icons.SmallIcon Icon={Icons.MagnifyingGlass} />}
                            placeholder="Search Comments"
                            value={search}
                            onChange={(e) => onSearchChange(e.target.value)}
                            size="xs"
                        />
                        <MapCommentFilterMenu
                            creatorId={creatorId}
                            onCreatorChange={onCreatorChange}
                            sort={sort}
                            onSortChange={onSortChange}
                        >
                            <ButtonTertiary
                                LeftIcon={Icons.FilterList}
                                className="min-w-[34px] !px-0"
                            />
                        </MapCommentFilterMenu>
                        <CommentVisibilityMenu />
                    </div>
                )}
            </div>
        </div>
    )
}
